import React, { createContext, useContext, useState } from 'react';
import { createDialogManager } from './DialogManager.ts';
let sharedManager;
// Shared across React roots so Escape pops one global stack instead of one per root.
// TODO: move into the provider with destroy-on-unmount once the app is a single root.
function getSharedManager() {
    sharedManager !== null && sharedManager !== void 0 ? sharedManager : sharedManager = createDialogManager(window);
    return sharedManager;
}
const DialogManagerContext = /*#__PURE__*/ createContext(undefined);
export function DialogManagerProvider({ children }) {
    const [manager] = useState(getSharedManager);
    return /*#__PURE__*/ React.createElement(DialogManagerContext.Provider, {
        value: manager
    }, children);
}
export function useDialogManager() {
    const manager = useContext(DialogManagerContext);
    if (manager == undefined) throw new Error('DialogManagerProvider is missing — wrap your app in <DialogManagerProvider>');
    return manager;
}
